define([
    './directives/NavBarDirective',
    'edge/platform/widgets/pagestructure/module',
    'edge/quoteandbind/app',
    'edge/platform/l10n/module',
    'edge/platform/util/module',
	'customerEdge/addressstandardization/app'
], (NavBarDirective)=> {
    return angular.module('portal.app', [
            'ui.router',
            'edge.platform.widgets.pagestructure',
            'edge.platform.l10n',
            'edge.quoteandbind.app',
            'edge.platform.util',
	        'customerEdge.addressstandardization.app',
			'ngSanitize'
            // 'reCaptcha' *Princy,
            // 'angularjs-crypto'
        ])
        .directive('gwPortalNavBar', NavBarDirective);
});



/** WEBPACK FOOTER **
 ** ./app/js/portal/app.js
 **/